import { area, multiselect } from '../../../packages/configs/filter-builder';
import { socioEconomicDemographicsFiltersParcels } from '../../../packages/configs/census-tools';
import {
  parcelFilters,
  saleAndForeclosureFilters,
  ownershipAndOccupancyFilters,
  propertyTaxes,
  zoningDevelopment,
  neighborhoodRedevelopment,
  // codeEnforcementFilters,
  transactionFilters,
} from '../../../packages/configs/filter-sets';

// const codeEnf = codeEnforcementFilters({
//   exclude: ['open_violation_type'],
// });

export const filters = [
  area(),
  ...transactionFilters(),
  ...saleAndForeclosureFilters(),
  ...ownershipAndOccupancyFilters(),
  ...propertyTaxes({
    overrides: {
      tax_status: multiselect({
        key: 'tax_status',
        label: 'Current Tax Status',
        options: [
          {
            label: 'Pick a filter',
            value: 'EMPTY',
          },
          {
            label: 'Tax Current',
            value: 'Tax Current',
          },
          {
            label: 'Tax Exempt',
            value: 'Tax Exempt',
          },
          {
            label: 'Tax Delinquent',
            value: 'Tax Delinquent',
          },
          {
            label: 'Tax Forfeiture',
            value: 'Tax Foreclosable',
          },
        ],
      }),
    },
  }),
  ...zoningDevelopment(),
  ...neighborhoodRedevelopment(),
  // ...codeEnf,
  ...socioEconomicDemographicsFiltersParcels(),
  ...parcelFilters({
    append: [
      multiselect({
        key: 'neighborhood',
        label: 'Neighborhood Planning Council',
      }),
      multiselect({
        key: 'neighborhood_2',
        label: 'CDBG Target Area',
      }),
    ],
  }),
];
